﻿'use strict';

angular.module('ntmApp').factory('DragFromRPToQCActivities', ['DraggingObject', 'DailyPlanService', 'FlashService', 'DailyPlanConfirmationService', 'WatchDndTargetsService', 'ActivitiesGroupSkillsValidator', 'ActivitySkillsValidator',
    function (DraggingObject, DailyPlanService, FlashService, DailyPlanConfirmationService, WatchDndTargetsService, ActivitiesGroupSkillsValidator, ActivitySkillsValidator) {

        function DragFromRPToQCActivities(view) {

            var self = this;

            var onStartDraggingEvent = null;
            var onEndDraggingEvent = null;

            self.startDragging = function (staff) {

                if (onStartDraggingEvent) {
                    var allowed = onStartDraggingEvent(staff);

                    if (allowed) {
                        self.DraggingObject.setDraggingObject(staff);
                    }
                }
            };

            self.drag = function (staff) {

                var draggingInfo = view.getInfoForDraggingAction();

                draggingInfo.personId = staff.personId;
                draggingInfo.personName = staff.staffName;
                draggingInfo.availableTime = staff.available;
                draggingInfo.allTargetStaffSkill = staff.allTargetStaffSkill;

                if (draggingInfo.isSingleActivity) {

                    var startExcecuteDraggingToRow = function () {
                            proccessDragAndDropEventFromResourcePoolToGridRow(draggingInfo);
                    };

                    dndRowPreSaveCheck(draggingInfo, startExcecuteDraggingToRow);
                } 
            };

            self.endDragging = function () {
                if (!WatchDndTargetsService.DKeyPressed) {
                    self.DraggingObject.releaseDraggingObject();
                }
            };

            self.onStartDragging = function (event) {
                onStartDraggingEvent = event;
                return self;
            };

            self.onEndDragging = function (event) {
                onEndDraggingEvent = event;
                return self;
            };

            function dndRowPreSaveCheck(draggingInfo, functionToExcecute) {
                var activitiesTotalDuration = (draggingInfo.schedule.totalDuration / 60).toFixed(2);
                var sourceAndTargetDifference = activitiesTotalDuration - draggingInfo.availableTime;

                if (draggingInfo.availableTime < activitiesTotalDuration) {
                    DailyPlanConfirmationService.MoveFromResourcePool('Assigning ' + draggingInfo.personName +
                        ' to this activity will over-allocate it by ' +
                        sourceAndTargetDifference.toFixed(2) + 'hrs.')
                                           .Yes(functionToExcecute)
                                           .No(function () {
                                              view.defaultDndTargets();
                                           })
                                           .Ask();
                } else {
                    functionToExcecute();
                }
            }            

            function proccessDragAndDropEventFromResourcePoolToGridRow(dragInformation) {


                            if(!dragInformation.isStaffSkillsCheck)
                                {

                                var skillsValidator = new ActivitySkillsValidator({ speciesId: dragInformation.speciesId, speciesName: dragInformation.speciesName, activityId: dragInformation.activityId, activity: dragInformation.activity }, {}, { personId: dragInformation.personId, staffName: dragInformation.personName }, dragInformation.allTargetStaffSkill);

                                if (skillsValidator.isValid()) {
                                    dragInformation.isStaffSkillsCheck = true;
                                } else {
                                    var moveFromResourcePool = function () { dragInformation.isStaffSkillsCheck = true; proccessDragAndDropEventFromResourcePoolToGridRow(dragInformation); };

                                    DailyPlanConfirmationService.MoveStaffFromResourcePoolToRoomActivityRow("{0} is not qualified for this activity.".format(dragInformation.personName))
                                                               .Yes(moveFromResourcePool)
                                                               .No(function () {
                                                                   view.defaultDndTargets();
                                                               })
                                                               .Ask();
                                }

                            } 

                            if (dragInformation.isStaffSkillsCheck) {

                                var loadingModal = FlashService.Loading();

                                var request = {
                                    facilityCode: dragInformation.facilityCode,
                                    roomNumber: dragInformation.roomNumber,
                                    date: dragInformation.date,
                                    scheduleId: dragInformation.scheduleId,
                                    personId: dragInformation.personId,
                                    personName: dragInformation.personName,
                                    activityName: dragInformation.activityName
                                };

                                DailyPlanService.DragFromResourcePoolToActivitiesGridRow(request).then(function (result) {
                                    loadingModal.dismiss();

                                    if (result.data) {
                                        FlashService.Success(result.data.message);
                                    }
                                });

                            }
             
            }

            function initialize() {
                self.DraggingObject = new DraggingObject();
                self.DraggingType = "DRAG_FROM_RESOURCE_POOL";
            }

            initialize();

        }

        return (DragFromRPToQCActivities);

    }]);